export const API = "https://memoir-api.herokuapp.com/api/v2";
// export const API = "http://localhost:3000/api/v2";
